import { pantryColors, pantryTypography } from '@pantry/ui'
import React from 'react'

const p = pantryColors
const F = pantryTypography.fontFamily

interface RuleCardProps {
  title: string
  icon: React.ReactNode
  children: React.ReactNode
}

export const RuleCard: React.FC<RuleCardProps> = ({
  title,
  icon,
  children,
}) => (
  <div
    style={{
      background: p.white,
      border: `1px solid ${p.gray[200]}`,
      borderRadius: 10,
      overflow: 'hidden',
      fontFamily: F,
    }}
  >
    <div style={{ padding: 20 }}>
      <div
        style={{
          fontSize: 13,
          fontWeight: 700,
          color: p.gray[800],
          marginBottom: 12,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span style={{ color: p.brand.primary, display: 'flex' }}>{icon}</span>
        {title}
      </div>
      <div>{children}</div>
    </div>
  </div>
)
